<div class="popup-modal">
    <div class="content-container">
      <mat-icon id="close-icon" (click)="closeDialog()">close</mat-icon>
      <span class="message-popup">{{data.message}}</span>
    </div>
    <div class="center-button">
    <!-- <button mat-flat-button id="no-button" [mat-dialog-close]="false">No</button> -->
    <button mat-flat-button id="yes-button" [mat-dialog-close]="true" class="btn btn-danger">Ok</button>
  </div>
  </div>